import { useState } from "react";

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQSectionProps {
  items: FAQItem[];
  title?: string;
  description?: string;
}

export default function FAQSection({ items, title, description }: FAQSectionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section>
      {title && (
        <h3 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2">
          {title}
        </h3>
      )}
      {description && (
        <p className="text-foreground-600 text-sm mb-6">{description}</p>
      )}
      <div className="space-y-3">
        {items.map((item, index) => (
          <div
            key={index}
            className="border border-background-200/70 rounded-lg overflow-hidden"
          >
            <button
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
              className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer bg-background-50 hover:bg-background-100 transition-colors"
            >
              <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                {item.question}
              </span>
              <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                <i
                  className={`text-lg text-foreground-400 transition-transform duration-200 ${
                    openIndex === index ? "ri-subtract-line" : "ri-add-line"
                  }`}
                ></i>
              </span>
            </button>
            {openIndex === index && (
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}